import { Location } from 'src/types/helios/Location';

/**
 * Transforms location codes (strings) to Location objects.
 * Used when opening the LocationSelectionPanel to convert stored codes
 * into full Location objects for display and selection.
 *
 * @param codes - Array of location codes (e.g., ['US-CA', 'US-NY'])
 * @param allLocations - Complete list of available Location objects
 * @returns Array of Location objects matching the provided codes
 */
export const transformCodesToLocations = (
  codes: string[],
  allLocations: Location[],
): Location[] => {
  return allLocations.filter((loc) => codes.includes(loc.locationCode));
};

/**
 * Extracts location codes from Location objects.
 * Used when closing the LocationSelectionPanel to convert selected
 * Location objects back to codes for storage.
 *
 * @param locations - Array of Location objects
 * @returns Array of location codes (e.g., ['US-CA', 'US-NY'])
 */
export const extractCodes = (locations: Location[]): string[] => {
  return locations.map((loc) => loc.locationCode || '');
};
